import logo from '@/assets/72FilmFestFinalLogo_horz.png';
export const LOGO_HEADER = logo;
